module.exports = __webpack_public_path__ + "static/media/second_declension_neuter_img.15b8edee.JPG";